export default __webpack_public_path__ + "static/media/lloyds-register.eb0abd4c.svg";